import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class DeviceStatusConverter implements JsonCustomConvert<DeviceStatus>{
	serialize() { }
	deserialize(data: any): DeviceStatus {
		switch (data) {
			case 'ONLINE':
				{
					return DeviceStatus.ONLINE;
				}
			case 'OFFLINE':
				{
					return DeviceStatus.OFFLINE;
				}
			case 'PENDING':
				{
					return DeviceStatus.PENDING;
				}
			default:
				{
					return DeviceStatus.OFFLINE;
				}
		}
	}
}

export enum DeviceStatus {
	ONLINE = 'ONLINE',
	OFFLINE = 'OFFLINE',
	PENDING = 'PENDING',
	ALL = ''
}
